


import React, {useState, useEffect } from 'react';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import {useSelector, useDispatch } from 'react-redux';
import Footer from './footer';
import Header from './header';
import { Link, withRouter, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Loader from 'react-loader-spinner';
import { CreateDioceseOfficial, CreateProfile, CreateEducation, EditEducation } from '../redux/action';
import { IMAGEPATH } from '../redux/action/constant';


const EditSelectedEducation = (props) => {

    const [ show, setshow ] = useState(false);
    const [ edit, setedit ] = useState(false);
    const { handleSubmit, errors, register, watch } = useForm();
	const dispatch = useDispatch();
    const [IsSubmitting, setIsSubmitting ] = useState(false);
    const { id } = useParams();
    const [ file, setfile ] = useState(null);
    const dioceanofficials = useSelector(state=>state.root.dioceanofficials);
    const month = useSelector(state => state.root.month);
    const year = useSelector(state => state.root.year);


    const eduSubmit = async (data,e) => {
        setIsSubmitting(true);
        let dioceseId = window.atob(id);
        await dispatch(EditEducation(data, props.education.id));
        setIsSubmitting(false);
    }


    useEffect(() => {
       // alert(month[0]);
       //alert(JSON.stringify(props.education.endyear));
        // let start = 1950;
        // let allstart = [];
        // for(let r = 0; r < 100; r++)
        // {
        //     allstart.push({ id: start+r });
        // }
        // setyear(allstart);
    },[])

    return (
        <div className="">
        <div style={{marginTop:30}}>
        <form onSubmit={handleSubmit(eduSubmit)}>
        <div className="row"  style={{marginBottom:20}}>
            <div className="col-lg-12 col-sm-12">
            <input 
                type = "text"
                placeholder = "Name of Institution"
                className="form-control" 
                name = "institution"
                defaultValue={props.education.institution}
                ref={register({
                required: "Required"
                })}
            />
                <small className="text-danger">{errors.name?.type == "required" && "Institution is required"}</small>
            </div>
            
        </div>
        <div className="row"  style={{marginBottom:20}}>
            <div className="col-lg-6 col-sm-6">
            <input 
                className="form-control" 
                placeholder ="Course" 
                name ="course"
                defaultValue={props.education.course}
                type ="text" 
                ref={register({
                    required: "Required"
                    })}
            />
                <small className="text-danger">{errors.institution?.type == "required" && "Name is required"}</small>
            </div>
            <div className="col-lg-6 col-sm-6">
            <input 
                className="form-control" 
                placeholder ="Qualification" 
                name ="qualification"
                defaultValue={props.education.qualification}
                type ="text" 
                ref={register({
                    required: "Required"
                    })}
            />
                <small className="text-danger">{errors.qualification?.type == "required" && "Required"}</small>
            </div>
        </div>
        <div className="row"  style={{marginBottom:20}}>
            <div className="col-lg-6 col-sm-6">
            <select 
                ref={register({
                required: "Required"
                })}
                name = "startmonth"
                defaultValue={props.education.startmonth}
                className="form-control">
            <option value="">Select Start Month</option>
            {
                month != null && month.map((mon,x) =>
                <option value={mon}>{mon}</option>
                )
            }
            </select>
                <small className="text-danger">{errors.startmonth?.type == "required" && "Required"}</small>
            </div>
            <div className="col-lg-6 col-sm-6">
            <select 
                name = "startyear"
                ref={register({
                required: "Required"
                })}
                defaultValue={props.education.startyear}
                className="form-control">
            <option value="">Select Start Year</option>
            {
                year != null && year.map((y) =>
                <option value={y.id}>{y.id}</option>
                )
            }
            </select>
                <small className="text-danger">{errors.startyear?.type == "required" && "Start Year is required"}</small>
            </div>
        </div>
        <div className="row"  style={{marginBottom:20}}>
            <div className="col-lg-6 col-sm-6">
            <select 
                ref={register({
                    required: "Required"
                    })}
                name = "endmonth"
                defaultValue={props.education.endmonth}
                className="form-control">
            <option value="">Select End Month</option>
            {
                month != null && month.map((mon) =>
                <option value={mon}>{mon}</option>
                )
            }
            </select>
                <small className="text-danger">{errors.endmonth?.type == "required" && "Required"}</small>
            </div>
            <div className="col-lg-6 col-sm-6">
            <select 
                name = "endyear"
                defaultValue="1968"
                ref={register({
                    required: "Required"
                    })}
                className="form-control">
            <option value="">Select End Year</option>
            {
                year != null && year.map((y) =>
                <option value={y.id}>{y.id}</option>
                )
            }
            </select>
                <small className="text-danger">{errors.endyear?.type == "required" && "Required"}</small>
            </div>
        </div>
                      
        <div className="row" style={{marginTop:10}}>
            <div className="col-lg-4 col-sm-4">
            <div style={{marginTop:0}} class="">
            {
            IsSubmitting == false &&
            <button type ="submit" class="mdc-button mdc-button--raised">
                Submit
            </button>
            }
            {
            IsSubmitting == true &&
            <div style={{textAlign:'center'}}>
            <Loader
                visible={true}
                type="Puff"
                color="#7a00ff"
                height={30}
                width={30}
                timeout= {0} //3 secs
            />
            </div>
            }
        </div>
            </div>
            
        </div>
        </form>
        </div>
     </div>
    );
}

export default EditSelectedEducation;

